import React from 'react';
import { Box, Typography, TextField } from '@material-ui/core';
import { FFTableDateRangeFilter as FFTableDateRangeFilterProps } from './types';
import { useFFTableStyles } from './styles';

export function FFTableDateRangeFilter({
  fromDate,
  untilDate,
  onDateRangeChange,
}: FFTableDateRangeFilterProps) {
  const classes = useFFTableStyles();

  const handleFromDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const dateValue = event.target.value
        ? new Date(event.target.value)
        : undefined;
      onDateRangeChange(dateValue, untilDate);
    } catch (error) {
      console.error('Invalid date format', error);
    }
  };

  const handleUntilDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    try {
      const dateValue = event.target.value
        ? new Date(event.target.value)
        : undefined;
      onDateRangeChange(fromDate, dateValue);
    } catch (error) {
      console.error('Invalid date format', error);
    }
  };

  // Format date to YYYY-MM-DD for input
  const formatDateForInput = (date: Date | undefined): string => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <Box className={classes.dateRangeContainer}>
      <Typography variant="body1">from</Typography>
      <Box display="flex" alignItems="center" ml={1}>
        <TextField
          id="from-date"
          label="From"
          type="date"
          variant="outlined"
          size="small"
          value={formatDateForInput(fromDate)}
          onChange={handleFromDateChange}
          className={classes.dateRangePicker}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            max: formatDateForInput(untilDate) || undefined,
          }}
          required
        />
        <Box mx={2}>
          <Typography variant="body1">to</Typography>
        </Box>
        <TextField
          id="until-date"
          label="Until"
          type="date"
          variant="outlined"
          size="small"
          value={formatDateForInput(untilDate)}
          onChange={handleUntilDateChange}
          className={classes.dateRangePicker}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            min: formatDateForInput(fromDate) || undefined,
          }}
          required
        />
      </Box>
    </Box>
  );
}

export default FFTableDateRangeFilter;
